@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.grey-637381 {
  color: var(--gray-637381);
}

.panel-content {
  background: var(--grey-100);
  height: 100%;
}

.title-row {
  padding: @space-24;
  align-items: center;
  justify-content: space-between;
}

.loading-indicator {
  display: flex;
  height: 100px;
  align-items: center;
}

.button {
  display: flex;
  align-items: center;
}

.table-section {
  gap: @space-16;
}

.button-icon {
  height: 16px;
  width: 16px;
  margin-right: @space-4;
}

.actions-cell {
  justify-content: center;
}

.status-cell {
  align-items: center;
}

.status-icon {
  height: 20px;
  width: 20px;
  padding: @space-4;
}

.check-icon {
  color: var(--green-700);
}

.error-icon {
  color: var(--red-700);
}
